// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"72c2e913","196":"f2c181d6","688":"8a9d350f","847":"6d545020"}[chunkId] + ".chunk.css";
};